<div *ngIf="favoriteListers.length">
  <div class="wrapper-cards-lister">
    <div *ngFor="let lister of favoriteListers" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, lister.username]" class="wrapper-card-lister">
      <div class="wrapper-favorite-lister">
        <div class="wrapper-avatar">
          <img [src]="lister.profile_photo_url !== null ? lister.profile_photo_url : '../../../../assets/images/avatar-user.png'" alt="">
        </div>
        <div class="wrapper-user-info">
          <div class="wrapper-username">
            <span>{{lister.name}}</span>
            <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../assets/icons/fill/icon-badge.svg" alt="">
            <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.company" src="./assets/icons/fill/icon-fill-company.svg" alt="">
          </div>
          <span>{{lister.followers_count}} {{lister.followers_count === 1 ? ('GENERAL.followers' | translate) : ('GENERAL.followers' | translate)}}</span>
        </div>
      </div>
    </div>
  </div>
  <button [routerLink]="PAGES_AND_PATHS.favoriteListers.pagePath" class="custom-btn custom-btn--gray">
    <span>{{'NEW_TEXT.view_all_listers' | translate}}</span>
  </button>
</div>
<div *ngIf="!favoriteListers.length" class="no-data-box">
  <span>No data</span>
</div>
